import Service from '@ember/service';
import Evented from '@ember/object/evented';
import { task, waitForEvent } from 'ember-concurrency';
import { isTesting, macroCondition } from '@embroider/macros';

export default class ResizeListener extends Service.extend(Evented) {
  start = task({ onState: null }, async () => {
    if (macroCondition(isTesting())) {
      return;
    }

    while (true) {
      await waitForEvent(globalThis, 'resize');
      this.trigger('resized');
    }
  });

  triggerResize = () => {
    this.trigger('resized');
  };
}
